import type { components } from '@fluencelabs/vodopad-admin-api'
import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { unwrapApiData } from '@/api/unwrapApiResult'

import { DASHBOARD_STALE_TIME, PAGE_SIZE } from './constants'

export type AdminUserVmDto = components['schemas']['AdminUserVmDto']

const ALL_VMS_QUERY_KEY = ['dashboard', 'allVms'] as const

export async function fetchAllVms(): Promise<AdminUserVmDto[]> {
  const allVms: AdminUserVmDto[] = []

  let page = 1
  let totalPages = 1

  while (page <= totalPages) {
    const res = await client.GET('/v2/admin/vms', {
      params: { query: { page, perPage: PAGE_SIZE } },
    })
    const data = unwrapApiData(res, 'Failed to fetch VMs')
    allVms.push(...data.items)
    totalPages = data.pagination.totalPages
    page++
  }

  return allVms
}

export const allVmsQueryOptions = {
  queryKey: ALL_VMS_QUERY_KEY,
  queryFn: fetchAllVms,
  staleTime: DASHBOARD_STALE_TIME,
  // A retry restarts the whole page walk (graph @cloudless/fluence, #2248).
  retry: false,
}

export function useAllVms() {
  return useQuery(allVmsQueryOptions)
}
